import styled from 'styled-components';
import { alpha } from '../../../themes/brand';

export const Container = styled.div`
  padding: 24px;
  height: 100%;
  display: flex;
  flex-direction: column;
  
  @media (max-width: 1024px) {
    padding: 16px;
  }
  
  @media (max-width: 768px) {
    padding: 12px;
  }
  
  @media (max-width: 480px) {
    padding: 8px;
  }
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  gap: 16px;
  
  @media (max-width: 1024px) {
    flex-wrap: wrap;
    gap: 12px;
    margin-bottom: 20px;
  }
  
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: stretch;
    gap: 16px;
    margin-bottom: 16px;
  }
`;

export const BackButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border: none;
  background-color: ${props => props.theme.background};
  color: ${props => props.theme.text};
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s;
  border: 1px solid ${props => props.theme.border};
  flex-shrink: 0;

  &:hover {
    background-color: ${props => props.theme.background};
    opacity: 0.8;
  }
  
  @media (max-width: 768px) {
    width: 44px;
    height: 44px;
    border-radius: 8px;
  }
  
  @media (max-width: 480px) {
    width: 40px;
    height: 40px;
  }
`;

export const FolderInfo = styled.div`
  flex: 1;
  margin-left: 0;
  min-width: 0;
  
  @media (max-width: 768px) {
    text-align: center;
  }
`;

export const FolderName = styled.h1`
  color: ${props => props.theme.text};
  margin: 0 0 4px 0;
  font-size: 24px;
  font-weight: 600;
  word-break: break-word;
  
  @media (max-width: 1024px) {
    font-size: 22px;
  }
  
  @media (max-width: 768px) {
    font-size: 20px;
    margin: 0 0 6px 0;
  }
  
  @media (max-width: 480px) {
    font-size: 18px;
  }
`;

export const FolderStats = styled.div`
  color: ${props => props.theme.textSecondary};
  font-size: 14px;
  
  @media (max-width: 768px) {
    font-size: 13px;
  }
  
  @media (max-width: 480px) {
    font-size: 12px;
  }
`;

export const HeaderActions = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  
  @media (max-width: 1024px) {
    gap: 12px;
    flex-wrap: wrap;
  }
  
  @media (max-width: 768px) {
    width: 100%;
    justify-content: center;
    flex-wrap: wrap;
    gap: 8px;
  }
`;

export const ViewToggle = styled.div`
  display: flex;
  background-color: ${props => props.theme.background};
  border: 1px solid ${props => props.theme.border};
  border-radius: 6px;
  overflow: hidden;
`;

export const ViewButton = styled.button<{ active: boolean }>`
  padding: 8px 12px;
  border: none;
  background-color: ${props => props.active ? props.theme.primary : 'transparent'};
  color: ${props => props.active ? props.theme.primaryOn : props.theme.text};
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background-color: ${props => props.active ? props.theme.primary : props.theme.background};
    opacity: ${props => props.active ? '1' : '0.8'};
  }
  
  @media (max-width: 768px) {
    padding: 12px 16px;
    min-height: 44px;
    min-width: 44px;
  }
  
  @media (max-width: 480px) {
    padding: 10px 12px;
    min-height: 40px;
    min-width: 40px;
  }
`;

export const ActionButton = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  background-color: ${({ theme }) => theme.primary};
  color: ${({ theme }) => theme.primaryOn};
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.2s;

  &:hover {
    background-color: ${({ theme }) => theme.primary};
  }

  svg {
    flex-shrink: 0;
  }
  
  @media (max-width: 768px) {
    width: 100%;
    justify-content: center;
    padding: 12px 16px;
    font-size: 16px;
    min-height: 48px;
  }
  
  @media (max-width: 480px) {
    padding: 10px 14px;
    font-size: 14px;
    min-height: 44px;
  }
`;

export const UploadArea = styled.div<{ dragActive: boolean }>`
  margin-bottom: 24px;
  padding: 40px 20px;
  border: 2px dashed ${props => props.dragActive ? props.theme.primaryAccent : props.theme.border};
  border-radius: 8px;
  text-align: center;
  cursor: pointer;
  transition: all 0.2s;
  background-color: ${props => props.dragActive ? '${({ theme }) => alpha(theme.primary, 0.1)}' : props.theme.background};

  &:hover {
    border-color: ${({ theme }) => theme.primaryAccent};
    background-color: ${({ theme }) => alpha(theme.primary, 0.05)};
  }

  svg {
    color: ${({ theme }) => theme.primaryAccent};
    margin-bottom: 8px;
  }
  
  @media (max-width: 768px) {
    margin-bottom: 20px;
    padding: 32px 16px;
    border-radius: 12px;
  }
  
  @media (max-width: 480px) {
    margin-bottom: 16px;
    padding: 24px 12px;
    border-radius: 8px;
  }
`;

export const UploadText = styled.div`
  color: ${props => props.theme.text};
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 4px;
  
  @media (max-width: 768px) {
    font-size: 15px;
  }
  
  @media (max-width: 480px) {
    font-size: 14px;
  }
`;

export const FileInput = styled.input`
  display: none;
`;

export const FilesContainer = styled.div<{ viewMode: 'grid' | 'list' }>`
  display: ${props => props.viewMode === 'grid' ? 'grid' : 'flex'};
  ${props => props.viewMode === 'grid' 
    ? `
      grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
      gap: 16px;
    `
    : `
      flex-direction: column;
      gap: 8px;
    `
  }
  flex: 1;
  margin-top: 16px;
  
  @media (max-width: 1024px) {
    ${props => props.viewMode === 'grid' 
      ? `
        grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
        gap: 14px;
      `
      : `
        gap: 6px;
      `
    }
  }
  
  @media (max-width: 768px) {
    ${props => props.viewMode === 'grid' 
      ? `
        grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
        gap: 12px;
      `
      : `
        gap: 8px;
      `
    }
    margin-top: 12px;
  }
  
  @media (max-width: 480px) {
    ${props => props.viewMode === 'grid' 
      ? `
        grid-template-columns: 1fr;
        gap: 12px;
      `
      : `
        gap: 6px;
      `
    }
    margin-top: 10px;
  }
`;

export const FileCard = styled.div<{ viewMode: 'grid' | 'list' }>`
  display: flex;
  ${props => props.viewMode === 'grid' 
    ? `
      flex-direction: column;
      padding: 16px;
      min-height: 120px;
    `
    : `
      flex-direction: row;
      align-items: center;
      padding: 12px 16px;
      min-height: 60px;
    `
  }
  background-color: ${props => props.theme.background};
  border: 1px solid ${props => props.theme.border};
  border-radius: 8px;
  transition: all 0.2s;
  position: relative;

  &:hover {
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    border-color: ${({ theme }) => theme.primaryAccent};
  }
  
  @media (max-width: 1024px) {
    ${props => props.viewMode === 'grid' 
      ? `
        padding: 14px;
        min-height: 110px;
      `
      : `
        padding: 10px 14px;
        min-height: 56px;
      `
    }
  }
  
  @media (max-width: 768px) {
    ${props => props.viewMode === 'grid' 
      ? `
        padding: 12px;
        min-height: 100px;
      `
      : `
        padding: 12px 16px;
        min-height: 60px;
        flex-wrap: wrap;
        gap: 8px;
      `
    }
    
    &:hover {
      transform: none;
    }
  }
  
  @media (max-width: 480px) {
    ${props => props.viewMode === 'grid' 
      ? `
        padding: 10px;
        min-height: 90px;
      `
      : `
        padding: 10px 12px;
        min-height: 56px;
      `
    }
  }
`;

export const FileIcon = styled.div`
  color: ${({ theme }) => theme.primaryAccent};
  flex-shrink: 0;
`;

export const FileInfo = styled.div`
  flex: 1;
  min-width: 0;
`;

export const FileName = styled.h4`
  color: ${props => props.theme.text};
  margin: 0 0 4px 0;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.2;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  
  @media (max-width: 768px) {
    font-size: 13px;
    white-space: normal;
    word-break: break-word;
    overflow: visible;
    text-overflow: unset;
  }
  
  @media (max-width: 480px) {
    font-size: 12px;
  }
`;

export const FileDetails = styled.div`
  color: ${props => props.theme.textSecondary};
  font-size: 12px;
  line-height: 1.4;
  
  @media (max-width: 768px) {
    font-size: 11px;
  }
  
  @media (max-width: 480px) {
    font-size: 10px;
  }
`;

export const FileActions = styled.div`
  position: absolute;
  top: 8px;
  right: 8px;
  display: flex;
  gap: 4px;
  opacity: 0;
  transition: opacity 0.2s;

  ${FileCard}:hover & {
    opacity: 1;
  }
  
  @media (max-width: 768px) {
    position: static;
    opacity: 1;
    justify-content: center;
    width: 100%;
    margin-top: 8px;
    gap: 8px;
    order: 3;
  }
`;

export const ActionIcon = styled.button<{ danger?: boolean }>`
  width: 28px;
  height: 28px;
  border: none;
  background-color: ${props => props.theme.background};
  color: ${props => props.danger ? props.theme.error : props.theme.textSecondary};
  border-radius: 4px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

  &:hover {
    background-color: ${props => props.danger ? props.theme.error : props.theme.primary};
    color: ${({ theme }) => theme.primaryOn};
  }
  
  @media (max-width: 768px) {
    width: 36px;
    height: 36px;
    border-radius: 6px;
  }
  
  @media (max-width: 480px) {
    width: 32px;
    height: 32px;
  }
`;

export const LoadingContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 200px;
  color: ${props => props.theme.textSecondary};
`;

export const EmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 200px;
  color: ${props => props.theme.textSecondary};
  text-align: center;
  padding: 20px;

  svg {
    margin-bottom: 16px;
    opacity: 0.5;
  }

  h3 {
    color: ${props => props.theme.text};
    margin: 0 0 8px 0;
    font-size: 18px;
  }

  p {
    margin: 0 0 24px 0;
    font-size: 14px;
  }
  
  @media (max-width: 768px) {
    height: 180px;
    padding: 16px;
    
    h3 {
      font-size: 16px;
    }
    
    p {
      font-size: 13px;
      margin: 0 0 20px 0;
    }
  }
  
  @media (max-width: 480px) {
    height: 160px;
    padding: 12px;
    
    h3 {
      font-size: 15px;
    }
    
    p {
      font-size: 12px;
      margin: 0 0 16px 0;
    }
  }
`;

// Modal Styles
export const Modal = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`;

export const ModalContent = styled.div`
  background-color: ${props => props.theme.background};
  border-radius: 8px;
  border: 1px solid ${props => props.theme.border};
  width: 400px;
  max-width: 90vw;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
  
  @media (max-width: 768px) {
    width: 95vw;
    border-radius: 12px;
  }
  
  @media (max-width: 480px) {
    width: 98vw;
    border-radius: 8px;
  }
`;

export const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px 16px;
  border-bottom: 1px solid ${props => props.theme.border};
  
  @media (max-width: 768px) {
    padding: 16px 20px 12px;
  }
  
  @media (max-width: 480px) {
    padding: 14px 16px 10px;
  }
`;

export const ModalTitle = styled.h2`
  color: ${props => props.theme.text};
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  
  @media (max-width: 768px) {
    font-size: 16px;
  }
  
  @media (max-width: 480px) {
    font-size: 15px;
  }
`;

export const ModalCloseButton = styled.button`
  width: 32px;
  height: 32px;
  border: none;
  background-color: transparent;
  color: ${props => props.theme.textSecondary};
  border-radius: 4px;
  cursor: pointer;
  font-size: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;

  &:hover {
    background-color: ${props => props.theme.background};
    opacity: 0.8;
  }
`;

export const ModalBody = styled.div`
  padding: 20px 24px;
  
  @media (max-width: 768px) {
    padding: 16px 20px;
  }
  
  @media (max-width: 480px) {
    padding: 14px 16px;
  }
`;

export const ModalFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 16px 24px 20px;
  border-top: 1px solid ${props => props.theme.border};
  
  @media (max-width: 768px) {
    flex-direction: column-reverse;
    gap: 8px;
    padding: 12px 20px 16px;
  }
  
  @media (max-width: 480px) {
    padding: 10px 16px 14px;
  }
`;

export const CancelButton = styled.button`
  padding: 8px 16px;
  border: 1px solid ${props => props.theme.border};
  border-radius: 6px;
  background-color: transparent;
  color: ${props => props.theme.text};
  cursor: pointer;
  font-size: 14px;
  transition: all 0.2s;

  &:hover {
    background-color: ${props => props.theme.background};
    opacity: 0.8;
  }
  
  @media (max-width: 768px) {
    padding: 12px 20px;
    font-size: 16px;
    min-height: 48px;
    width: 100%;
  }
  
  @media (max-width: 480px) {
    padding: 10px 16px;
    font-size: 14px;
    min-height: 44px;
  }
`;

export const ConfirmButton = styled.button`
  padding: 8px 16px;
  border: none;
  border-radius: 6px;
  background-color: ${({ theme }) => theme.primary};
  color: ${({ theme }) => theme.primaryOn};
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.2s;

  &:hover:not(:disabled) {
    background-color: ${({ theme }) => theme.primary};
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
  
  @media (max-width: 768px) {
    padding: 12px 20px;
    font-size: 16px;
    min-height: 48px;
    width: 100%;
  }
  
  @media (max-width: 480px) {
    padding: 10px 16px;
    font-size: 14px;
    min-height: 44px;
  }
`;

export const ErrorMessage = styled.div`
  padding: 12px 16px;
  background-color: ${({ theme }) => theme.errorBackground};
  color: ${({ theme }) => theme.error};
  border: 1px solid ${({ theme }) => theme.error};
  border-radius: 6px;
  font-size: 14px;
  line-height: 1.4;
  white-space: pre-wrap;
`;

export const SuccessMessage = styled.div`
  padding: 12px 16px;
  background-color: ${({ theme }) => theme.successBackground};
  color: ${({ theme }) => theme.success};
  border: 1px solid ${({ theme }) => theme.success};
  border-radius: 6px;
  font-size: 14px;
  line-height: 1.4;
`; 